<!-- STAFF HEADER -->
<ng-container *ngIf="headerLayout === 'staff' && showProfileMenu">
  <div class="header-container">

    <div class="logo-container clickable" (click)="onSealIconClick()">
      <img [src]="logoSrc" alt="GeoPermits Logo" class="geopermit-logo" />
    </div>

    <div class="account-container clickable" [matMenuTriggerFor]="profileMenu">
      <!-- Start Code added by Sanchit on 05/06/2026 -->
      <span class="profile-name-typo">
        {{context.user?.name}}
      </span>
      <!-- End Code added by Sanchit on 05/06/2026 -->
      <img [src]="profileImageSrc" alt="Profile Image" class="profile-image" />
    </div>

    <mat-menu #profileMenu="matMenu">
      <div class="profile-menu-card">
        <wm-common-button
          *ngFor="let btn of menuButtons"
          [data]="btn">
        </wm-common-button>
      </div>
    </mat-menu>

  </div>
</ng-container>

<!-- APPLICANT HEADER -->
<ng-container *ngIf="headerLayout === 'applicant'">
  <div class="applicant-header" >
    <div class="geopermits-logo-container clickable" (click)="onSealIconClick()">
      <img [src]="logoSrc" alt="Seal" class="seal" />
    </div>
    <div class="profile-dropdown-container">
      <div
        class="applicant-account-container"
        [class.clickable]="showProfileMenu"
        (click)="toggleApplicantProfileMenu($event)"
      >
        <wm-common-text [data]="userNameData" class="name-header"></wm-common-text>
        <div class="applicant-avatar-frame">
          <img
            class="applicant-avatar-image"
            [src]="profileImageSrc"
            [ngClass]="profileImageClass"
            alt="Profile Image"
          />
        </div>
      </div>

      <!-- added by omkar on 18/03/2026 -->
      <div
        *ngIf="showProfileMenu && isApplicantProfileMenuOpen"
        class="profile-menu profile-menu-floating"
        role="menu"
        aria-label="Profile menu"
        (click)="$event.stopPropagation()"
      >
        <div class="profile-menu-list">
          <ng-template #tplEditProfile>
            <div class="menu-item">
              <wm-common-icon
                [data]="{
                  iconName: 'account_circle',
                  iconSet: 'material-icons-outlined'
                }"
              ></wm-common-icon>
              <span class="menu-label">Edit Profile</span>
            </div>
          </ng-template>
          <wm-common-button
            class="menu-item-btn"
            [data]="{ text: tplEditProfile, onClick: handleEditProfileClick }"
          ></wm-common-button>

          <ng-template #tplChangePassword>
            <div class="menu-item">
              <wm-common-icon [data]="{ iconName: 'password' }"></wm-common-icon>
              <span class="menu-label">Change password</span>
            </div>
          </ng-template>
          <wm-common-button
            class="menu-item-btn"
            [data]="{ text: tplChangePassword, onClick: handleChangePasswordClick }"
          ></wm-common-button>

          <ng-template #tplLogout>
            <div class="menu-item">
              <wm-common-icon [data]="{ iconName: 'logout' }"></wm-common-icon>
              <span class="menu-label">Logout</span>
            </div>
          </ng-template>
          <wm-common-button
            class="menu-item-btn logout"
            [data]="{ text: tplLogout, onClick: handleLogoutClick }"
          ></wm-common-button>
        </div>
      </div>
      <!-- end by omkar on 18/03/2026 -->
    </div>
  </div>
</ng-container>
